import { render } from "./NoFeeOrderManage.vue?vue&type=template&id=84516444&scoped=true"
import script from "./NoFeeOrderManage.vue?vue&type=script&lang=js"
export * from "./NoFeeOrderManage.vue?vue&type=script&lang=js"

import "./NoFeeOrderManage.vue?vue&type=style&index=0&id=84516444&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84516444"]])

export default __exports__